import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TRESPONSE_BUNDLE_TAG_DETAILS } from '@monorepo/types';
import { TranslateService } from '@ngx-translate/core';

export type TFields = { label: string; value?: string | number }[];

@Component({
  selector: 'monorepo-expand-bundle-tag-details-modal',
  templateUrl: './expand-bundle-tag-details-modal.component.html',
  styleUrls: ['./expand-bundle-tag-details-modal.component.scss'],
})
export class ExpandBundleTagDetailsModalComponent {
  @Input() title: string = 'common.details';
  @Input() fields: TFields = [];
  constructor(private modalController: ModalController, private translate: TranslateService) {}

  closeModal() {
    this.modalController.dismiss();
  }
}
